import React, { PureComponent } from 'react'
import { Row, Col, Button, message } from 'antd'
import { connect } from 'react-redux'
import io from 'socket.io-client'
import NoSleep from 'nosleep.js'

import {
  init1pConverterForm,
  run1pConverterRequest,
  run1pConverterSuccess,
  finish1pConverterOne,
} from '../../../../redux/actions/FormsActions'

import { writeConsole } from '../../../../redux/actions/FilesActions'

const noSleep = new NoSleep()

const socket = io(`${process.env.REACT_APP_SOCKET_HOST}/`, {
  rejectUnauthorized: false,
})

class Form extends PureComponent {
  componentDidMount() {
    this.props.init1pConverterForm()
    this.socketFunc()
  }

  socketFunc = () => {
    socket.connect()

    socket.on('connect_error', function(error) {
      console.log('connect_error', error)
    })

    socket.on('connect', function() {})

    // one finished
    socket.on('fileConverter1pFinished', uid => {
      this.props.finish1pConverterOne(uid)
    })

    // new log
    socket.on('fileConverter1pLog', log => {
      this.props.writeConsole(log, 'info')
    })

    // new warning
    socket.on('fileConverter1pWarning', log => {
      this.props.writeConsole(log, 'warning')
    })

    // processing finished
    socket.on('runConverter1pRes', uids => {
      this.props.run1pConverterSuccess(uids)
      noSleep.disable()
    })

    // processing error
    socket.on('runConverter1pError', error => {
      message.error(error.message)
      noSleep.disable()
    })
  }

  onParse() {
    const files = this.props.files.files
      .filter(item => item.status === 'uploaded')
      .map(item => item.uid)

    if (files.length === 0) {
      message.error('Загрузите по крайней мере один файл для обработки')
    } else if (files.length > 10) {
      message.error(
        'За один раз можно очищать не более десяти файлов. Удалите лишние файлы и загрузите их перед следующей загрузкой'
      )
    } else {
      socket.emit('runConverter1p', {
        uuids: files,
      })
      this.props.run1pConverterRequest(files)
      noSleep.enable()
    }
  }

  render() {
    const converterForm = this.props.forms.converter_1p

    return (
      <Row gutter={16}>
        <Col span={22}>
          <Button
            block
            type="primary"
            className={'Form__container'}
            style={{ marginBottom: '3rem' }}
            loading={converterForm.isLoading}
            onClick={e => this.onParse()}
          >
            Конвертировать
          </Button>
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = store => {
  return {
    files: store.files,
    forms: store.forms,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    init1pConverterForm: () => dispatch(init1pConverterForm()),
    run1pConverterRequest: uids => dispatch(run1pConverterRequest(uids)),
    run1pConverterSuccess: uids => dispatch(run1pConverterSuccess(uids)),
    writeConsole: (value, type = 'info') => dispatch(writeConsole(value, type)),
    finish1pConverterOne: uid => dispatch(finish1pConverterOne(uid)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form)
